import { render, staticRenderFns } from "./2_MedicalHistory.vue?vue&type=template&id=78b3045e&"
import script from "./2_MedicalHistory.vue?vue&type=script&lang=js&"
export * from "./2_MedicalHistory.vue?vue&type=script&lang=js&"
import style0 from "./2_MedicalHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports